import React from "react";
import { Navigate } from "react-router-dom";
import { storage } from "@/utils/Storage";

import { IRoleType } from "@/models/role";
import { ISessionKeys } from "@/models";

interface RouteGuardProps {
  children: React.ReactNode;
  allowedRoles: IRoleType[];
}

const RouteGuard: React.FC<RouteGuardProps> = ({ children, allowedRoles }) => {
  const roleType = storage.getSessionToken(
    ISessionKeys.ROLE_TYPE
  ) as IRoleType | null;

  // If user is not logged in, redirect to home
  if (!roleType) {
    return <>{children}</>;
  }

  // If user's role is not in allowed roles, redirect based on role
  if (!allowedRoles.includes(roleType)) {
    switch (roleType) {
      case IRoleType.DOCTOR:
      case IRoleType.JR_DOCTOR:
        return <Navigate to="/schedule" />;
      case IRoleType.PHARMACY:
      case IRoleType.DIAGNOSTIC_CENTER:
        return <Navigate to="/orders" />;
      default:
        return <Navigate to="/home" />;
    }
  }

  return <>{children}</>;
};

export default RouteGuard;
